import { gql } from "@apollo/client";export default gql`mutation deleteTopic($id: Int!) {
    deleteTopic: delete_group_by_pk(id: $id) {
        id
    }
}
`;
